import { featuresEnum } from '@/utils/featureUtils'

const Login = () => import('./pages/Login.vue')

const RegisterSteps = () => import('./pages/RegisterSteps')
const NewRegister = () => import('./pages/NewRegister')
const NewRegisterInvite = () => import('./pages/NewRegisterInvite')
const BusinessProfile = () => import('./pages/BusinessProfile')
const ConfirmRegister = () => import('./pages/ConfirmRegister')

const NewPassWord = () => import('./pages/NewPassWord')
const Recover = () => import('./pages/Recover')

const TheAuthContainer = () => import('@/containers/TheAuthContainer')
const TheContainerFluid = () => import('@/containers/TheContainerFluid')

const SocialMediaContainer = () => import('./pages/SocialMediaContainer.vue')
const Google = () => import('./pages/Google.vue')
const Linkedin = () => import('./pages/Linkedin.vue')

const OrganizationSelection = () => import('./pages/OrganizationSelection.vue')
const UserDisabled = () => import('./pages/UserDisabled.vue')
const NoOrganization = () => import('./pages/NoOrganization.vue')

const AcceptInvite = () => import('./pages/AcceptInvite.vue')

const TheContainer = () => import('@/containers/TheContainer')
const LoadSession = () => import('./pages/LoadSession.vue')
const BasicInfo = () => import('../user/pages/BasicInfo.vue')
const Security = () => import('../user/pages/Security.vue')
const TheMainSidebar = () => import('@/containers/TheMainSidebar')
const PrivacyPolicy = () => import('../legal/pages/PrivacyPolicy.vue')
const TermsAndConditions = () => import('../legal/pages/TermsAndConditions.vue')

const UserNotAllowed = () => import('./pages/UserNotAllowed.vue')

const Api = () => import('../user/pages/Api.vue')
const DocumentationWrapper = () => import('@/views/api/pages/DocumentationWrapper.vue')

const MainOrganization = () => import('@/views/organization/pages/MainOrganization.vue')

const authRoutes = [
  {
    path: '/auth',
    redirect: '/auth/login',
    component: TheAuthContainer,
    children: [
      {
        path: '/auth/login',
        name: 'Login',
        component: Login,
      },
      {
        path: '/auth/privacy-policy',
        name: 'privacy-policy-login',
        component: PrivacyPolicy,
      },
      {
        path: '/auth/terms-and-conditions',
        name: 'terms-and-conditions-login',
        component: TermsAndConditions,
      },
      {
        path: '/auth/login/invite/:inviteId',
        name: 'LoginWithInvite',
        component: Login,
      },
      {
        path: '/auth/register',
        redirect: '/auth/register/new-register',
        component: RegisterSteps,
        children: [
          // MVP2-1772
          {
            path: '/auth/register/new-register',
            name: 'NewRegister',
            component: NewRegister,
            meta: { feature_flag: featuresEnum.ACCOUNT_REGISTER }
          },
          {
            path: '/auth/register/new-register-invite/:inviteId',
            name: 'NewRegisterInvite',
            component: NewRegisterInvite,
          },
          {
            path: '/auth/register/new-register/external/:name/:email',
            name: 'NewRegister-External',
            component: NewRegister,
            meta: { feature_flag: featuresEnum.ACCOUNT_REGISTER }
          },
          {
            path: '/auth/register/business-profile',
            name: 'BusinessProfile',
            component: BusinessProfile,
          },
          {
            path: '/auth/register/confirm-register',
            name: 'ConfirmRegister',
            component: ConfirmRegister,
          },
          {
            path: '/auth/register/confirm-register',
            name: 'ConfirmRegisterInvite',
            component: ConfirmRegister,
          },
        ],
      },
      {
        path: '/auth/new-password/:token?/:id?', // TODO: REMOVER DEPOIS DE VALIDADO
        name: 'newPasswordRecovery',
        component: NewPassWord,
      },
      {
        path: '/auth/recovery',
        name: 'recovery',
        component: Recover,
      },
    ],
  },
  {
    path: '/auth',
    component: TheContainer,
    children: [
      {
        path: 'organization',
        name: 'OrganizationSelection',
        component: OrganizationSelection,
        meta: { requiresAuth: true },
      },
      {
        path: 'noOrganization',
        name: 'NoOrganization',
        component: NoOrganization,
      },
      // {
      //   path: 'settings',
      //   component: TheMainSidebar,
      //   children: [
      //     {
      //       path: 'user/basic-info',
      //       name: 'basic-info-default',
      //       component: BasicInfo,
      //       meta: { requiresAuth: true, menuType: 'Profile' },
      //     },
      //     {
      //       path: 'security',
      //       name: 'security-default',
      //       component: Security,
      //       meta: { requiresAuth: true, menuType: 'Profile' },
      //     },
      //     {
      //       path: 'user/api',
      //       name: 'api-key-default',
      //       component: Api,
      //       meta: { requiresAuth: true, menuType: 'Profile' },
      //     },
      //   ],
      // },
    ],
  },
  {
    path: 'settings-default',
    component: TheContainerFluid,
    children: [
      {
        path: '',
        name: 'settings-default',
        redirect: 'user/basic-info',
        component: TheMainSidebar,
        children: [
          {
            path: 'user/basic-info',
            name: 'basic-info-default',
            component: BasicInfo,
            meta: { requiresAuth: true, menuType: 'Profile' },
          },
          {
            path: 'user/security',
            name: 'security-default',
            component: Security,
            meta: { requiresAuth: true, menuType: 'Profile' },
          },
          {
            path: 'user/api',
            name: 'api-key-default',
            component: Api,
            meta: { requiresAuth: true, menuType: 'Profile' },
          },
          {
            path: 'organization/createOrganization',
            name: 'createOrganization-default',
            component: MainOrganization,
            meta: { requiresAuth: true, menuType: 'Organization Default' },
          },
        ],
      },
    ],
  },
  {
    path: '/api-documentation',
    name: 'documentation-default',
    component: DocumentationWrapper,
    meta: { requiresAuth: true },
  },

  // {
  //   path: '/auth/organization',
  //   component: TheContainer,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'OrganizationSelection',
  //       component: OrganizationSelection,
  //       meta: { requiresAuth: true },
  //     },
  //   ],
  // },
  // {
  //   path: '/auth/noOrganization',
  //   component: TheContainer,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'NoOrganization',
  //       component: NoOrganization,
  //     },
  //   ],
  // },
  {
    path: '/auth/userdisabled',
    component: TheContainer,
    children: [
      {
        path: '/',
        name: 'Userdisabled',
        component: UserDisabled,
      },
    ],
  },
  {
    path: '/auth/acceptInvite/:inviteId',
    name: 'AcceptInvite',
    component: AcceptInvite,
  },
  {
    path: '/auth/external',
    name: 'external',
    component: SocialMediaContainer,
    children: [
      {
        path: '/auth/external/google/callback',
        name: 'google',
        component: Google,
      },
      {
        path: '/auth/external/linkedin/callback',
        name: 'linkedin',
        component: Linkedin,
      },
    ],
  },
  {
    path: '/auth/load/:organizationId?',
    name: 'load',
    component: LoadSession,
  },
  {
    path: '/auth/notAllowed/:organizationId?',
    name: 'notAllowed',
    component: UserNotAllowed,
  },
]

export default authRoutes
